const isTopWindowAccessible = () => {
    try {
        if (!window.top) {
            throw new Error('window.top is not an object');
        }
        // check if it mutable
        window.top.audienzzCheck = Math.random();
        return true;
    }
    catch {
        return false;
    }
};
export { isTopWindowAccessible };
